<template>
  <div class="catalogue-alter">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>会刊提交</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/exinfo/catalogue');">
          <span>返回</span>
        </div>
      </div>
    </div>
    
    <div class="catalogue-alter-content" v-if="catalogueDownInfo">
      <Form
        ref="formInline"
        :model="formInline"
        label-position="right"
        :label-width="200"
        @submit.native.prevent
        style="width:calc(100% - 130px);"
      >
        <FormItem label="提交时间：">
          <p class="alter-p">{{catalogueDownInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</p>
        </FormItem>
        <FormItem label="审核状态：">
          <p class="alter-p">待审核</p>
        </FormItem>
        <FormItem label="操作状态：">
          <p class="alter-p">修改</p>
        </FormItem>
        <FormItem label="公司名称：">
          <p class="alter-p">{{catalogueDownInfo.compName}}</p>
        </FormItem>
        <FormItem label="展位号：">
          <p class="alter-p" v-if="formInline.exHall">{{formInline.exHall}}</p>
          <p class="alter-p" v-else></p>
        </FormItem>
        <FormItem label="公司英文名：">
          <p class="alter-p" :style="tag || tagCompNameEn? 'color:red':''">{{catalogueDownInfo.compNameEn}}</p>
        </FormItem>
        <FormItem label="国家：">
          <p class="alter-p" :style="tag || tagArea? 'color:red':''">{{catalogueDownInfo.area}}</p>
        </FormItem>
        <FormItem label="省份：">
          <p class="alter-p" :style="tag || tagProvince? 'color:red':''">{{catalogueDownInfo.province}}</p>
        </FormItem>
        <FormItem label="城市：">
          <p class="alter-p" :style="tag || tagCity? 'color:red':''">{{catalogueDownInfo.city}}</p>
        </FormItem>
        <FormItem label="地址：">
          <p class="alter-p" :style="tag || tagAddress? 'color:red':''">{{catalogueDownInfo.address}}</p>
        </FormItem>
        <FormItem label="邮政编码：">
          <p class="alter-p" :style="tag || tagPostcode? 'color:red':''">{{catalogueDownInfo.postcode}}</p>
        </FormItem>
        <FormItem label="英文地址：">
          <p class="alter-p" :style="tag || tagAddressEn? 'color:red':''">{{catalogueDownInfo.addressEn}}</p>
        </FormItem>
        <!-- <FormItem label="企业类型：">
          <p class="alter-p" :style="tag || tagIndustry? 'color:red':''">{{catalogueDownInfo.industry}}</p>
        </FormItem>
        <FormItem label="人员规模：">
          <p class="alter-p" :style="tag || tagScale? 'color:red':''">{{catalogueDownInfo.scale}}</p>
        </FormItem>
        <FormItem label="年销售额：">
          <p class="alter-p" :style="tag || tagAnnualSales? 'color:red':''">{{catalogueDownInfo.annualSales}}</p>
        </FormItem> -->
        <FormItem label="公司网址：">
          <p class="alter-p" :style="tag || tagWebsite? 'color:red':''">{{catalogueDownInfo.website}}</p>
        </FormItem>
        <FormItem label="公司邮箱：">
          <p class="alter-p" :style="tag || tagEmail? 'color:red':''">{{catalogueDownInfo.email}}</p>
        </FormItem>
        <FormItem label="联系人姓氏：">
          <p class="alter-p" :style="tag || tagLinkFirstName? 'color:red':''">{{catalogueDownInfo.linkFirstName}}</p>
        </FormItem>
        <FormItem label="联系人名字：">
          <p class="alter-p" :style="tag || tagLinkLastName? 'color:red':''">{{catalogueDownInfo.linkLastName}}</p>
        </FormItem>
        <FormItem label="联系人手机：">
          <p class="alter-p" :style="tag || tagLinkMob? 'color:red':''">{{catalogueDownInfo.linkMob}}</p>
        </FormItem>
        <FormItem label="联系人电话：">
          <p class="alter-p" :style="tag || tagLinkTel? 'color:red':''">{{catalogueDownInfo.linkTel}}</p>
        </FormItem>
        <FormItem label="传真：">
          <p class="alter-p" :style="tag || tagLinkFax? 'color:red':''">{{catalogueDownInfo.linkFax}}</p>
        </FormItem>
        <FormItem label="会刊中文简介：">
          <p class="alter-p" :style="tag || tagIntroduction? 'color:red':''">{{catalogueDownInfo.introduction}}</p>
        </FormItem>
        <FormItem label="会刊英文简介：">
          <p class="alter-p" :style="tag || tagIntroductionEn? 'color:red':''">{{catalogueDownInfo.introductionEn}}</p>
        </FormItem>
        <!-- <FormItem label="中文公司简介及产品简介：">
          <p class="alter-p" :style="tag || tagProfile? 'color:red':''">{{catalogueDownInfo.profile}}</p>
        </FormItem>
        <FormItem label="英文公司简介及产品简介：">
          <p class="alter-p" :style="tag || tagProfileEn? 'color:red':''">{{catalogueDownInfo.profileEn}}</p>
        </FormItem> -->
        <FormItem label="Logo：">
          <div class="my-upload-list" v-if="catalogueDownInfo.logo">
            <div>
              <img :style="tag || taglogo? 'border:1px solid red':''" :src="catalogueDownInfo.logo" style="width: 150px;height: 150px;border:1px solid #ccc;" />
            </div>
            <div class="logo-example-box">
              <div class="logo-example-item z-large-s" style="height:40px;">
                <img :style="tag || taglogo? 'border:1px solid red':''" :src="catalogueDownInfo.logo" style="width: 40px;height: 40px;border:1px solid #ccc;" />
                <p>图片尺寸：200*200px</p>
              </div>
              <div class="logo-example-item z-large-m" style="height:30px;">
                <img :style="tag || taglogo? 'border:1px solid red':''" :src="catalogueDownInfo.logo" style="width: 30px;height: 30px;border:1px solid #ccc;" />
                <p>图片尺寸：120*120px</p>
              </div>
              <div class="logo-example-item z-large-l" style="height:20px;">
                <img :style="tag || taglogo? 'border:1px solid red':''" :src="catalogueDownInfo.logo" style="width: 20px;height: 20px;border:1px solid #ccc;" />
                <p>图片尺寸：30*30px</p>
              </div>
            </div>
          </div>
          <div v-else>N/A</div>
        </FormItem>
      </Form>
      <Button style="position:absolute;top:30px;right:30px;" @click="$router.push('/exhibition/index/exinfo/catalogue-alter-edit')">修改待审核信息</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"; 
import config from '@assets/config.json';

export default {
  name: "exhibition-info-catalogueAlter",
  data() {
    return {
      formInline: {
        name: "", // 公司名称
        exHall: "", // 展位号，修改时不用提交
        enName: "", // 英文名
        country: "中国",
        province: "",
        city: "",
        address: "", // 地址
        mail: "", // 邮政编码
        enAddress: "", //英文地址
        // type: "", // 企业类型
        // staff: "", // 人员规模
        // sales: "", // 年销售额
        url: "", // 公司网址
        email: "", // 公司邮箱
        LinkFirstName: "", // 联系人姓氏
        LinkLastName: "", // 联系人名字
        LinkMob: "", // 联系人手机号码
        LinkTel1: "",
        LinkTel2: "",
        LinkTel3: "",
        LinkFax1: "",
        LinkFax2: "",
        LinkFax3: "",
        introduction: "", // 会刊中文简介
        enIntroduction: "", // 会刊英文简介
        profile: "", // 中文公司简介及产品简介
        enProfile: "", // 英文公司简介及产品简介
      },
      catalogueInfo: null, // 会刊信息内容
      catalogueDownInfo: null, // 会刊信息提交的修改内容
      tag: false,
      tagCompNameEn: false,
      tagArea: false,
      tagProvince: false,
      tagCity: false,
      tagAddress: false,
      tagPostcode: false,
      tagAddressEn: false,
      // tagIndustry: false,
      // tagScale: false,
      // tagAnnualSales: false,
      tagWebsite: false,
      tagEmail: false,
      tagLinkFirstName: false,
      tagLinkLastName: false,
      tagLinkMob: false,
      tagLinkTel: false,
      tagLinkFax: false,
      tagIntroduction: false,
      tagIntroductionEn: false,
      tagProfile: false,
      tagProfileEn: false,
      taglogo: false,
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany", 
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  async created() {
    this.formInline.name = this.company.name;
    // if (this.joinInfo && this.joinInfo.boothInfo) {
    //   let boothInfo = JSON.parse(this.joinInfo.boothInfo);
    //   for (let i = 0; i < boothInfo.length; i++) {
    //     if (boothInfo.length > 1) {
    //       this.formInline.exHall += boothInfo[i].Hall + '-' + boothInfo[i].Code + '、';
    //     } else {
    //       this.formInline.exHall += boothInfo[i].Hall + '-' + boothInfo[i].Code;
    //     }
    //   }
    //   // this.formInline.exHall = boothInfo.Hall + boothInfo.Code;
    // }
    if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
        if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
          this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
        }
      }
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
        if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
          this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
        }
        if (this.joinInfo.boothInfo.Hall) {
          this.formInline.exHall = this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
        } else {
          this.formInline.exHall = this.joinInfo.boothInfo.Code;
        }
      }
      if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
        let boothInfo = this.joinInfo.boothInfo;
        for (let i = 0; i < boothInfo.length; i++) {
          if (boothInfo.length > 1) {
            if (boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
            }
            if (boothInfo[i].Hall && !boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "、";
            }
            if (!boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Code + "、";
            }
            
          } else {
            if (boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall + "-" + boothInfo[i].Code;
            }
            if (boothInfo[i].Hall && !boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Hall;
            }
            if (!boothInfo[i].Hall && boothInfo[i].Code) {
              this.formInline.exHall +=
                boothInfo[i].Code;
            }

          }
        }
      }
      // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
    }
    // 获取会刊信息
    let res = await this.getCatalogueByJoinId(this.joinInfo.joinId);
    if (res) {
      this.catalogueInfo = res;
    }

    // 获取会刊修改记录
    let result = await this.getCatalogueDown(this.joinInfo.joinId);
    if (result) {
      this.catalogueDownInfo = result;
    }

    // 会刊信息不存在，说明为新增，所有信息红色
    if (!this.catalogueInfo) {
      this.tag = true;
    }
    // 会刊信息存在，修改的信息为红色
    if (this.catalogueInfo) {
      if (this.catalogueInfo.compNameEn !== this.catalogueDownInfo.compNameEn) {
        this.tagCompNameEn = true;
      };
      if (this.catalogueInfo.area !== this.catalogueDownInfo.area) {
        this.tagArea = true;
      };
      if (this.catalogueInfo.province !== this.catalogueDownInfo.province) {
        this.tagProvince = true;
      };
      if (this.catalogueInfo.city !== this.catalogueDownInfo.city) {
        this.tagCity = true;
      };
      if (this.catalogueInfo.address !== this.catalogueDownInfo.address) {
        this.tagAddress = true;
      };
      if (this.catalogueInfo.postcode !== this.catalogueDownInfo.postcode) {
        this.tagPostcode = true;
      };
      if (this.catalogueInfo.addressEn !== this.catalogueDownInfo.addressEn) {
        this.tagAddressEn = true;
      };
      // if (this.catalogueInfo.industry !== this.catalogueDownInfo.industry) {
      //   this.tagIndustry = true;
      // };
      // if (this.catalogueInfo.scale !== this.catalogueDownInfo.scale) {
      //   this.tagScale = true;
      // };
      // if (this.catalogueInfo.annualSales !== this.catalogueDownInfo.annualSales) {
      //   this.tagAnnualSales = true;
      // };
      if (this.catalogueInfo.website !== this.catalogueDownInfo.website) {
        this.tagWebsite = true;
      };
      if (this.catalogueInfo.email !== this.catalogueDownInfo.email) {
        this.tagEmail = true;
      };
      if (this.catalogueInfo.linkFirstName !== this.catalogueDownInfo.linkFirstName) {
        this.tagLinkFirstName = true;
      };
      if (this.catalogueInfo.linkLastName !== this.catalogueDownInfo.linkLastName) {
        this.tagLinkLastName = true;
      };
      if (this.catalogueInfo.linkMob !== this.catalogueDownInfo.linkMob) {
        this.tagLinkMob = true;
      };
      if (this.catalogueInfo.linkTel !== this.catalogueDownInfo.linkTel) {
        this.tagLinkTel = true;
      };
      if (this.catalogueInfo.linkFax !== this.catalogueDownInfo.linkFax) {
        this.tagLinkFax = true;
      };
      if (this.catalogueInfo.introduction !== this.catalogueDownInfo.introduction) {
        this.tagIntroduction = true;
      };
      if (this.catalogueInfo.introductionEn !== this.catalogueDownInfo.introductionEn) {
        this.tagIntroductionEn = true;
      };
      if (this.catalogueInfo.profile !== this.catalogueDownInfo.profile) {
        this.tagProfile = true;
      };
      if (this.catalogueInfo.profileEn !== this.catalogueDownInfo.profileEn) {
        this.tagProfileEn = true;
      };
      if (this.catalogueInfo.logo !== this.catalogueDownInfo.logo) {
        this.taglogo = true;
      };
    }
  },
  methods: {
    ...mapActions({
      getCatalogueDown: "exhibitionModule/getCatalogueDown",
      getCatalogueByJoinId: "exhibitionModule/getCatalogueByJoinId",
    }),
  }
};
</script>

<style lang="scss">
.catalogue-alter {
  .ivu-form-item {
    margin-bottom: 0;
  }
}
</style>
<style scoped lang="scss">
.catalogue-alter {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    position: relative;
  }
  .my-upload-list {
    width: 400px;
    height: 180px;
    display: flex;
    .logo-example-box {
      margin-left: 10px;
      color: #808080;
      .logo-example-item {
        display: flex;
        margin-bottom: 10px;
        font-size: 12px;
        p {
          display: flex;
          align-self: flex-end;
          margin-left: 10px;
        }
      }
    }
  }
  .alter-p {
    line-height: 34px;
  }
}
</style>
